var render, staticRenderFns
import script from "./vPage.vue?vue&type=script&lang=js&"
export * from "./vPage.vue?vue&type=script&lang=js&"
import style0 from "./vPage.vue?vue&type=style&index=0&id=d28ddc86&lang=scss&scoped=true&"
import style1 from "./vPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28ddc86",
  null
  
)

export default component.exports